import apiContent from '@/api/public/content';

const defaultState = () => ({
	content: {},
	loadContent: false,
	contentDetail: '',
	contentPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setContent(state, data) {
		state.content = data.data.reduce(function(rv, x) {
			(rv[x['content_category']] = rv[x['content_category']] || []).push(x);
			return rv;
		}, {});
		state.contentPagination = data.pagination;
	},
	setLoadContent(state, data) {
		state.loadContent = data
	},
	setDetailContent(state, data) {
		state.contentDetail = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearContent(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	async getContent({ commit }, params) {
		commit('setLoadContent', true);
		return new Promise((resolve) => {
			apiContent.getContent(params).then(({ data: { data } }) => {
				commit('setContent', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setContent', { data: [], pagination: {} });
			}).then(() => {
				commit('setLoadContent', false);
			});
		});
	},
	async detailContent({ commit }, params) {
		commit('setLoadContent', true);
		return new Promise((resolve, reject) => {
			apiContent.detailContent(params).then(({ data: { data } }) => {
				commit('setDetailContent', data.results);
				resolve(true);
			}).catch((err) => {
				commit('setDetailContent', {});
				reject(err)
			}).then(() => {
				commit('setLoadContent', false);
			});
		});
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};